import React, { Component, Fragment } from 'react';
import { Row, Col, Navbar, Nav, Button, Form, Modal } from 'react-bootstrap';
import { LineChart, Line, Tooltip, XAxis } from 'recharts';
import { TableKPI } from './KPITables';

function getdate(dateBack){
    var d = new Date();
    d = d.setDate(d.getDate() - dateBack);
    var n = new Date(d).toLocaleDateString();
    return n;
}

export class SimpleLineChart extends Component {
    constructor(props){
        super(props);

        this.state = {
            daysago7 : 0,
            daysago6 : 0,
            daysago5 : 0,
            daysago4 : 0,
            daysago3 : 0,
            daysago2 : 0,
            daysago1 : 0,
        };

    }

    componentDidUpdate(prevProps){
        if(prevProps.days !== this.props.days){
            var data = this.props.days[0];
            this.setState({
                daysago7 : data.daysago7,
                daysago6 : data.daysago6,
                daysago5 : data.daysago5,
                daysago4 : data.daysago4,
                daysago3 : data.daysago3,
                daysago2 : data.daysago2,
                daysago1 : data.daysago1,
            });
        }
        
    }

    render () {       
        const data = [
            {name: getdate(7) , searches: this.state.daysago7 },
            {name: getdate(6), searches: this.state.daysago6 },
            {name: getdate(5), searches: this.state.daysago5 },
            {name: getdate(4), searches: this.state.daysago4 },
            {name: getdate(3), searches: this.state.daysago3 },
            {name: getdate(2), searches: this.state.daysago2 },
            {name: getdate(1), searches: this.state.daysago1 },
        ];

        return (
            <LineChart width={500} height={200} data={data}
            margin={{top: 20, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="name" hidden/>
            <Tooltip />
            <Line type="monotone" dataKey="searches" stroke="#8884d8" activeDot={{r: 8}}/>
            </LineChart>
        );
    }
}

export default class SearchMetrics extends Component {
    constructor(props){
        super(props);

        this.state = {
            fetchProMetric : [],
            isLoading: true
        };
    }

    componentDidMount(){
        this.setState({
            fetchProMetric : this.props.metric,
            metricNames: ["Today","Current_Week","This_Month","This_Year","Yesterday","Last_Week","Last_Month","Last_Year"],
            isLoading: false
        });
    }


    componentDidUpdate(prevProps){
        if(prevProps.metric !== this.props.metric){
            this.setState({
                fetchProMetric: this.props.metric,
                metricNames: ["Today","Current_Week","This_Month","This_Year","Yesterday","Last_Week","Last_Month","Last_Year"],
                isLoading: false
            });
        }
    }

    render(){
        if(this.state.isLoading){
            return <div>Loading....</div>;
        }

        return (
            <div> 
                {this.state.fetchProMetric.map((items, index) =>
                <Row className="SearchMetric" key={index}>
                    <Col lg={{span : 12 }}><p className="mt-4 header">{items["Type"].substr(2,100).replace("_"," ")}</p></Col>                       
                    {this.state.metricNames.map((key,index) => 
                        <Col lg={{span : 3 }} key={index} >
                            <div className="kpi-box" style={{ cursor: "default", color: "rgb(165, 165, 165)" }}>
                                <p className="mb-0">{key.replace("_"," ")}</p> 
                                <h1>{parseInt(items[key])}</h1>
                            </div>
                        </Col>
                    )}
                </Row>
                )}
            </div> 
        );
    }
}

